module.exports = "/dist/2a52a20f9a56010ec5d985abe9bebcc9.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500.eot
// module id = 30
// module chunks = 0